import AElf from 'aelf-sdk';
export const getNextBIP44Path = (BIP44Path) => {
    const BIPArr = BIP44Path.split('/');
    if (isNaN(+BIPArr[BIPArr.length - 1]))
        return "m/44'/1616'/0'/0/0";
    BIPArr.splice(-1, 1, (+BIPArr[BIPArr.length - 1] + 1).toString());
    return BIPArr.join('/');
};
export function isEqAddress(a1, a2) {
    return (a1 === null || a1 === void 0 ? void 0 : a1.toLocaleLowerCase()) === (a2 === null || a2 === void 0 ? void 0 : a2.toLocaleLowerCase());
}
export function isPrivateKey(privateKey) {
    try {
        if (privateKey && typeof privateKey === 'string')
            return Uint8Array.from(Buffer.from(privateKey, 'hex')).length === 32;
    }
    catch (error) {
        return false;
    }
    return false;
}
export function handlePrivateKey(privateKey) {
    if (privateKey.slice(0, 2) === '0x')
        privateKey = privateKey.slice(2);
    return privateKey;
}
export const isValidBase58 = (str) => {
    return !/[\u4e00-\u9fa5\u3000-\u303f\uff01-\uff5e]/.test(str);
};
export function isELFAddress(value) {
    if (!value || !isValidBase58(value))
        return false;
    if (value.includes('_') && value.split('_').length < 3)
        return false;
    try {
        return !!AElf.utils.decodeAddressRep(value);
    }
    catch (_a) {
        return false;
    }
}
export var SupportedChainId;
(function (SupportedChainId) {
    SupportedChainId["AELF"] = "AELF";
    SupportedChainId["tDVV"] = "tDVV";
    SupportedChainId["tDVW"] = "tDVW";
})(SupportedChainId || (SupportedChainId = {}));
export function isELFAddressSuffix(value) {
    if (!value)
        return false;
    if (isELFAddress(value)) {
        const arr = value.split('_');
        if (arr && arr.length === 3 && Object.values(SupportedChainId).includes(arr[2])) {
            return true;
        }
    }
    return false;
}
export const removeAddressSuffix = (address) => {
    const arr = address.split('_');
    if (arr.length === 3)
        return arr[1];
    return address;
};
export const removeELFAddressSuffix = (address) => {
    if (isELFAddressSuffix(address))
        return removeAddressSuffix(address);
    return address;
};
